import { Sentry } from '@/components/Sentry';
import { NarrativeFairValueModal } from '@/components/NarrativeFairValue';

import type { WatchlistItem } from '@/hooks/useWatchlist';

import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';

import { useWatchlistNarrativeFairValue } from './useWatchlistNarrativeFairValue';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  watchlistItem: WatchlistItem;
  watchlistId: string;
};

export const WatchlistNarrativeFairValueModal = ({
  isOpen,
  onClose,
  watchlistItem,
  watchlistId,
}: Props) => {
  const { company } = watchlistItem;
  const narrativeFairValue = useWatchlistNarrativeFairValue({ watchlistItem });

  const companyCurrencyISO =
    getTradingItemCurrencyISO(company.data.currencyInfo) ?? 'XXX';

  if (!watchlistId) return null;

  const {
    npvPerShare = null,
    priceTarget = null,
    lastSharePrice = null,
    priceTargetAnalystCount = null,
  } = company.analysisValue || {};

  return (
    <Sentry sentryCapture={{ team: 'narwhals' }} globalDisabled>
      <NarrativeFairValueModal
        isModalOpen={isOpen}
        onClose={onClose}
        companyName={company.name}
        uniqueSymbol={company.tickerSymbol}
        companyId={company.id}
        watchlistId={watchlistId}
        priceTargetAnalystCount={priceTargetAnalystCount ?? 0}
        defaultUserFairValue={narrativeFairValue?.fairValue}
        existingValuationType={narrativeFairValue?.type}
        companyCurrencyISO={companyCurrencyISO}
        npvPerShare={npvPerShare}
        priceTarget={priceTarget}
        currentPrice={lastSharePrice}
        valuationId={narrativeFairValue.valuationId}
        narrativeId={narrativeFairValue.narrativeId}
        watchlistItemId={watchlistItem.id}
        isExistingNarrative={
          narrativeFairValue.narrativeId !== null &&
          narrativeFairValue.narrativeId !== ''
        }
      />
    </Sentry>
  );
};
